// @mui
// hooks
import {Button, Checkbox, FormControlLabel, Stack} from "@mui/material";
import {useTheme} from "@mui/material/styles";
import {useEffect, useState} from "react";
import Tour from "reactour";
import {useLocation} from "react-router-dom";
import PropTypes from "prop-types";
import Iconify from "../../../components/Iconify";
import {IconButtonAnimate} from "../../../components/animate";
import useSettings from "../../../hooks/useSettings";
import useAuth from "../../../hooks/useAuth";
import {getDashboardTour} from "./dashboardTours";
// components

// ----------------------------------------------------------------------

StartTourButton.propTypes = {
    onDoNotShowAgainCheck: PropTypes.func,
    onJumpClick: PropTypes.func,
    goTo: PropTypes.func,
};

function StartTourButton({onDoNotShowAgainCheck, onJumpClick, goTo}) {
    return (
        <Stack width={1} direction="column" justifyContent="flex-end" spacing={1} sx={{mt: 2}}>
            <FormControlLabel
                control={
                    <Checkbox
                        size="small"
                        color="primary"
                        onChange={(event) => onDoNotShowAgainCheck(event.target.checked)}
                        icon={<Iconify icon={'eva:radio-button-off-outline'}/>}
                        checkedIcon={<Iconify icon={'eva:checkmark-circle-2-outline'}/>}
                    />
                }
                label="Não abrir este tour automaticamente"
                sx={{minWidth: 72, mr: 0}}
            />
            <Stack width={1} direction="row" justifyContent="flex-end" spacing={1} sx={{mt: 2}}>
                <Button variant={"outlined"} onClick={() => onJumpClick(false)}>
                    Agora não
                </Button>
                <Button variant={"contained"} onClick={() => goTo(1)}>
                    Iniciar tour
                </Button>
            </Stack>
        </Stack>
    );
}

export default function HelpIcon() {
    const {pathname} = useLocation();
    const theme = useTheme();
    const {showTour, onChangeTour} = useSettings();
    const {workspace} = useAuth();
    const [tourOpen, setTourOpen] = useState(false);
    const [doNotShowAgain, setDoNotShowAgain] = useState(false);
    const [currentStep, setCurrentStep] = useState(0);

    useEffect(() => {
        setTourOpen(showTour);
        // The preference controls automatic opening only when the header mounts.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    const pageTour = getDashboardTour(pathname, {isAdmin: workspace?.isAdmin});
    const helperStyle = {
        backgroundColor: theme.palette.background.paper,
        color: theme.palette.text.primary,
        border: `1px solid ${theme.palette.divider}`,
    };
    const selectedTourConfig = [
        {
            selector: '',
            content: ({goTo}) => (
                <div>
                    <strong>{pageTour.title}</strong><br/><br/>
                    {pageTour.intro}
                    <StartTourButton
                        onDoNotShowAgainCheck={setDoNotShowAgain}
                        onJumpClick={setTourOpen}
                        goTo={goTo}
                    />
                </div>
            ),
        },
        ...pageTour.steps,
        {
            selector: '[data-tut="help"]',
            content: ({goTo}) => (
                <div>
                    Pronto — agora você conhece os recursos de <strong>{pageTour.title}</strong>.<br/><br/>
                    Quando quiser rever este tutorial, clique novamente no botão de ajuda.
                    <Stack width={1} direction="column" justifyContent="flex-end" spacing={1} sx={{mt: 2}}>
                        <Stack width={1} direction="row" justifyContent="flex-end" spacing={1} sx={{mt: 2}}>
                            <Button variant={"outlined"} onClick={() => goTo(0)}>
                                Recomeçar
                            </Button>
                            <Button variant={"contained"} onClick={() => setTourOpen(false)}>
                                Fechar
                            </Button>
                        </Stack>
                    </Stack>
                </div>
            ),
            stepInteraction: false,
        },
    ].map((step) => ({...step, style: helperStyle}));
    const [showTourCloseButton, setShowTourCloseButton] = useState(false);
    const [showTourNavButtons, setShowTourNavButtons] = useState(false);

    const openTour = () => {
        setTourOpen(true);
    };

    return (
        <>
            <IconButtonAnimate
                aria-label="Abrir ajuda"
                data-tut="help"
                onClick={openTour}
                sx={{
                    width: 40,
                    height: 40,
                    ...(tourOpen && {bgcolor: 'action.selected'}),
                }}
            >
                <Iconify icon={'eva:question-mark-circle-outline'}/>
            </IconButtonAnimate>
            <Tour
                onRequestClose={() => {
                    setTourOpen(false);
                }}
                steps={selectedTourConfig}
                isOpen={tourOpen}
                onBeforeClose={() => {
                    setCurrentStep(0);
                    onChangeTour(doNotShowAgain)
                }}
                goToStep={currentStep}
                showCloseButton={showTourCloseButton}
                closeWithMask={false}
                showNavigation={showTourNavButtons}
                showButtons={showTourNavButtons}
                getCurrentStep={(curr) => {
                    setCurrentStep(curr);
                    const maxLength = selectedTourConfig.length;
                    if (curr === 0) {
                        setShowTourNavButtons(false)
                        setShowTourCloseButton(false)
                    } else {
                        setShowTourNavButtons(true)
                        setShowTourCloseButton(true)
                    }
                    if (curr === maxLength - 1) {
                        setShowTourNavButtons(false)
                        setShowTourCloseButton(false)
                    }
                }}
                className="helper"
                rounded={5}
                accentColor={"#5cb7b7"}
                onAfterOpen={() => {
                    if (currentStep === 0) {
                        setShowTourNavButtons(false)
                        setShowTourCloseButton(false)
                    }
                }}
            />
        </>
    );
}
